export function getLayout(width: number) {
  if (width < 480) {
    return { columns: 4, size: 60 };
  }
  if (width < 768) {
    return { columns: 6, size: 70 };
  }
  return { columns: 8, size: 80 };
}
